export default {
  ad: {
    id: 'swap_ad_v2',
    defaultMessage:
      'Want to get this for even less? Like {price}*? Trade in your old tech for cash.',
  },
  purposal: {
    id: 'swap_buyback_intro_journey_purposal_v2',
    defaultMessage:
      '*Price shown is calculated based on the average order values and may vary',
  },
  yes: {
    id: 'swap_buyback_purposal_yes',
    defaultMessage: 'Yes',
  },
  yesSubtitle: {
    id: 'swap_buyback_purposal_yes_subtitle',
    defaultMessage: 'Estimate the buyback offer >',
  },
  no: {
    id: 'swap_buyback_purposal_no',
    defaultMessage: 'No',
  },
  title: {
    id: 'swap_buyback_purposal_plp_title',
    defaultMessage: 'See how Trade-in works',
  },
  subTitle: {
    id: 'swap_buyback_purposal_plp_sub_title',
    defaultMessage: 'Add an item to your cart in order to trade-in.',
  },
  listBadgeTitle: {
    id: 'swap_buyback_purposal_plp_list_badge_title',
    defaultMessage: 'Get an offer',
  },
  listBadgeDescription: {
    id: 'swap_buyback_purposal_plp_list_badge_description',
    defaultMessage:
      'See an offer from a professional refurbisher in about 2 minutes.',
  },
  listPackageTitle: {
    id: 'swap_buyback_purposal_plp_list_package_title',
    defaultMessage: 'Ship your trade-in for free',
  },
  listPackageDescription: {
    id: 'swap_buyback_purposal_plp_list_package_description',
    defaultMessage: "You'll have 21 days to ship your item.",
  },
  listMoneyTitle: {
    id: 'swap_buyback_purposal_plp_list_money_title',
    defaultMessage: 'Get cash money',
  },
  listMoneyDescription: {
    id: 'swap_buyback_purposal_plp_list_money_description',
    defaultMessage:
      "Once your item is received and accepted, you'll get a direct deposit within 5 business days.",
  },
  getOffer: {
    id: 'swap_buyback_purposal_plp_get_offer',
    defaultMessage: 'Get an offer',
  },
  introYesGetOfferMain: {
    id: 'swap_buyback_intro_yes_get_offer_main',
    defaultMessage: 'Yes',
  },
  introYesGetOfferSecondary: {
    id: 'swap_buyback_intro_yes_get_offer_secondary',
    defaultMessage: 'Get a trade-in offer in just 2 min',
  },
  introNoRefuseOfferMain: {
    id: 'swap_buyback_intro_no_refuse_offer_main',
    defaultMessage: 'No, not now',
  },
  introNoRefuseOfferSecondary: {
    id: 'swap_buyback_intro_no_refuse_offer_secondary',
    defaultMessage: 'View your cart',
  },
  introAtcEnhancedImageTitle: {
    id: 'swap_buyback_intro_enhanced_image_title',
    defaultMessage: 'Want to get this for even less?',
  },
  introAtcEnhancedImageSubtitle: {
    id: 'swap_buyback_intro_enhanced_image_subtitle',
    defaultMessage: 'Trade in old devices for cash',
  },
  introAtcEnhancedImageListItem1: {
    id: 'swap_buyback_intro_enhanced_image_list_item1',
    defaultMessage: 'Top offer guaranteed',
  },
  introAtcEnhancedImageListItem2: {
    id: 'swap_buyback_intro_enhanced_image_list_item2',
    defaultMessage: 'Free and insured shipping',
  },
  introAtcEnhancedImageListItem3: {
    id: 'swap_buyback_intro_enhanced_image_list_item3',
    defaultMessage: 'A second life for your device',
  },
  introAtcEnhancedAnimatedTitle: {
    id: 'swap_buyback_intro_enhanced_animated_title',
    defaultMessage:
      'Want to get this for even less? Trade-in your old tech for cash.',
  },
  introAtcEnhancedAnimatedTagText: {
    id: 'swap_buyback_intro_enhanced_animated_tag_text',
    defaultMessage: 'With trade-in estimation',
  },
  introAtcEnhancedAnimatedCaptionText: {
    id: 'swap_buyback_intro_enhanced_animated_caption_text',
    defaultMessage:
      '*Price shown is an estimate based on average order values. Actual savings may vary.',
  },
}
